
import React, { useState } from 'react';
import {
    FormControl,
    FormGroup,
    Icon,
    ImagePicker
} from 'components';
import {
  faBan
} from '@fortawesome/fontawesome-pro-solid';
import {
    faCheckCircle
} from '@fortawesome/fontawesome-pro-solid';
import { LOGOS } from 'lib/afterPayLogos'
import classNames from 'lib/classNames';
import styles from "styles/settings.module.scss";
const ProtectionIconSelector = ({ shopContext }) => {
    const {
        state: { settings: { icon } },
        setItem
    } = shopContext
    const [uploadedImage, setUploadedImage] = useState(icon.isExternal ? icon.image : null)
    const handleImageSelect = (image, isExternal = true) => {
        setItem("settings.icon.image", image)
        setItem("settings.icon.isExternal", isExternal)
        if (isExternal) {
            setUploadedImage(image)
        }
    }

    const selectedImage = icon?.image
    return (
        <>
        <FormGroup label="Design Upsell Product">
          <FormControl marginBottom="" label="Icon" >
            <div  className={classNames('flex items-center ')} >
                <div className={classNames('flex flex-wrap ')} >
                    {
                        LOGOS.map(({ src, id, style }, key) => {
                            return (
                                <div key={key} className={classNames('relative')} >
                                    <div key={id} className={classNames('flex justify-center items-center m-2 cursor-pointer overflow-hidden')} onClick={() => handleImageSelect(src, false)}>
                                        <img style={{ height: "50px" }} src={src} />
                                    </div>
                                    {selectedImage === src && <div className={classNames('absolute top-0 right-0')}> <Icon icon={faCheckCircle} color="#2f80ed" /> </div>}
                                </div>
                            )
                        })
                    }
                    <div  className={classNames('relative')} >
                        <div className={styles.iconWithText} onClick={() => handleImageSelect(null, false)} >
                            <Icon icon={faBan} /> 
                            <div className={styles.text}>
                                No Icon
                            </div>
                        </div>
                        {!selectedImage && <div className={classNames('absolute top-0 right-0')}> <Icon icon={faCheckCircle} color="#2f80ed" /> </div>}
                    </div>
                    {
                        !!uploadedImage &&
                        <div className={classNames('flex relative')}>
                            <div className={classNames('flex justify-center items-center m-2 cursor-pointer overflow-hidden	')} onClick={() => handleImageSelect(uploadedImage, true)}>
                                <img style={{ height: "50px" }} src={uploadedImage} />
                            </div>
                            {selectedImage === uploadedImage && <div className={classNames('absolute top-0 right-0')}> <Icon icon={faCheckCircle} color="#2f80ed" /> </div>}
                        </div>
                    }
                </div>
                <div className={classNames('m-2 flex justify-center items-center ')}>
                    <ImagePicker onChange={handleImageSelect} simplified={true} />
                </div>
            </div>
            </FormControl>
          </FormGroup>
        </>
    )

}

              {/* <div className={styles.icons}>
              {
                DEFAULT_ICONS.map((icon, key) => (
                 <div key={key} className={styles.singleIcon} onClick={() => onIconSelect(icon)}> <Icon icon={icon} /> </div>
                ))
              }
                <div className={styles.iconWithText}  onClick={() => onIconSelect(null)}> 
                  <Icon icon={faBan} /> 
                  <div className={styles.text}>
                    No Icon
                  </div>
                </div>
                <div className={styles.iconWithText}> 
                  <Icon icon={faPlus} /> 
                  <div className={styles.text}>
                    Custom
                  </div>
                </div>
              </div> */}
export default ProtectionIconSelector